module.exports = __webpack_public_path__ + "static/coffeetalk1-97269ce85833ae0db9b111501cd6982f.webp";